const isObject = (item: unknown): item is object => item != null && typeof item === 'object';

export function isEqual(obj1: unknown, obj2: unknown): boolean {
    if (obj1 === obj2) {
        return true;
    }

    if (obj1 == null && obj2 == null) {
        return obj1 === obj2;
    }

    const firstIsObject = isObject(obj1);
    const secondIsObject = isObject(obj2);

    if (
        firstIsObject !== secondIsObject ||
        !firstIsObject && !secondIsObject && obj1 != obj2
    ) {
        return false;
    }

    if (!firstIsObject && !secondIsObject && obj1 == obj2) {
        return true;
    }

    // how to beat typescript in this case without `any`?
    const first: object = obj1 as any;
    const second: object = obj2 as any;

    const props1 = Object.getOwnPropertyNames(first) as (keyof typeof first)[];
    const props2 = Object.getOwnPropertyNames(second) as (keyof typeof second)[];
    if (props1.length != props2.length) {
        return false;
    }

    for (let i = 0; i < props1.length; i++) {
        const val1 = first[props1[i]];
        const val2 = second[props1[i]];

        const isObjects = isObject(val1) && isObject(val2);
        if (isObjects && !isEqual(val1, val2) || !isObjects && val1 !== val2) {
            return false;
        }
    }

    return true;
}
